import { z } from 'zod';

export const LoginSchema = z
  .object({
    nome: z
      .string()
      .min(3, { message: 'Mínimo 3 caracteres' })
      .nonempty('O nome é de preenchimento obrigatório.'),
    email: z
      .string()
      .min(1, { message: 'O e-mail é de preenchimento obrigatório.' })
      .email({ message: 'O e-mail inserido não é válido' }),
    terms: z
      .boolean()
      .refine((val) => val === true, { message: 'É necessário estar de acordo para continuar.' }),
    profissao: z.enum(['arquiteto', 'estudante', 'engenheiro', 'construtor', 'outro'], {
      errorMap: () => ({ message: 'A profissão é de preenchimento obrigatório.' }),
    }),
    outro: z.string().optional(),
  })
  .refine(
    (data) => {
      if (data.profissao === 'outro') {
        return data.outro && data.outro.trim() !== '';
      }
      return true;
    },
    {
      path: ['outro'],
      message: 'Por favor, especifique sua profissão.',
    },
  );

export type LoginData = z.infer<typeof LoginSchema>;
